<ng-container *ifScreenSize="screenType.Mobile">
  <div
    class="page-header"
    [ngClass]="{ 'hide-footer': !showFooter, 'bg-all-star': isFreePopulation, 'bg-primary': !isFreePopulation }"
  >
    <div class="d-flex align-items-center text-white">
      <div class="banner-name">
        <a (click)="goBack()" class="btn back-btn text-white px-0">
          <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
        </a>
        <h4 class="page-title mb-0" [ngClass]="{ 'text-title-center': !showBalance }">
          {{ pageTitle | translate | uppercase }}
        </h4>
      </div>
      <div *ngIf="showBalance" class="ms-auto d-flex align-items-center widget-details">
        <div class="balance-details d-flex bg-glass align-items-center">
          <span class="icons material-icons"> loyalty </span>
          <div class="balance">
            <p class="mb-0 font-size-14 fw-bold">{{ pointsBalance$ | async | number: '1.0-0' : 'en-GB' }}</p>
          </div>
        </div>

        <button *ngIf="showQr" class="qrcode-btn text-white bg-glass" (click)="gotoWallet()">
          <span class="icon material-icons material-mobile-nav">qr_code_2</span>
        </button>
      </div>
    </div>
    <div class="footer"></div>
  </div>
</ng-container>
